angular.module('unergie.main')
.directive('fieldValidation', () =>
    ({
        restrict: 'E',
        templateUrl: '/directives/fieldValidation/fieldValidation.html',
        scope: {
            field: '=',
            mandatory: '=',
            message: '=',
            spin: '=',
        },
        link($scope, element) {
            $scope.tooltip = $scope.field ? 'Champ valide' : ($scope.message || `Champ ${$scope.mandatory ? 'obligatoire' : 'optionnel'}`)
            $scope.validation = (field) => {
                if ($scope.mandatory) {
                    return {
                        'fa-refresh fa-spin': $scope.spin,
                        'fa-check green': !$scope.spin && field,
                        'fa-times red': !$scope.spin && !field,
                    }
                }
                return {
                    'fa-refresh fa-spin': $scope.spin,
                    'fa-check green': !$scope.spin && field,
                    'fa-check grey': !$scope.spin && !field,
                }
            }
        },
    }),
)
